import { Injectable } from '@angular/core';
import { FeatureFlagsRulesService, Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { SaleAdvanceRepositoryBase } from '@skylab-shared/business';
import { ClientRepository } from '../client/client.repo';
import { ProductRepository } from '../product/product.repo';
export { SaleAdvanceRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(SaleAdvanceRepositoryBase)
export class SaleAdvanceRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
        clientRepository: ClientRepository,
        productRepository: ProductRepository,
        queryBus: QueryBus,
        featureFlagsRulesService: FeatureFlagsRulesService
    ) { }
}
